define('views/ProjectView',[
    'backbone',
    'lodash',
    'text!templates/project.html',
    'app',
    'lib/MouseAnim',
    'lib/easing',
    'flexslider'
], function (Backbone, _, projectTmpl, App, MouseAnim, easing) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        template: _.template(projectTmpl),

        events: {
            'click .flexslider-prev, .flexslider-next' : 'clickSlider'
        },

        initialize: function (params) {
            var project = this.project = params[0],
                projects = project.type === 'projects' ? App.projects : App.caseStudies,
                index = 0;

            // find out the next project
            if (projects.length > 1) {
                _.find(projects, function (p, i) {
                    if (p.id === project.id) {
                        index = i;
                        return true;
                    }
                });
                this.nextProject = index < projects.length - 1 ? projects[index + 1] : projects[0];
            }

            // different color theme for featured projects
            if (this.project.color) {
                this.$el.addClass(this.project.color + '-bg text-black');
            }
        },

        render: function () {
            this.$el.html(this.template(App));

            if (this.project.images.length) {
                this.initSlider();
            }
        },

        clickSlider: function (e) {
            var dir = e.currentTarget.className.match('prev') ? 'prev' : 'next';
            this.slider.flexslider(dir);
        },

        initSlider: function () {
            this.slider = this.$el.find('.flexslider');
            this.slider.flexslider({
                animation: "slide",
                directionNav: false,
                slideshowSpeed: 14000
            });

            if (this.project.images.length > 1) {
                this.initAnim();
            }
        },

        initAnim: function () {
            var $lftri = this.$el.find('.flexslider-prev .right-tri'),
                $rttri = this.$el.find('.flexslider-next .right-tri'),
                slider = this.slider;

            this.mouseAnim = new MouseAnim();
            this.mouseAnim.add(function (pos) {
                var offset = slider.offset(),
                    w = slider[0].offsetWidth,
                    h = slider[0].offsetHeight,
                    hide = w * 0.3, // width of area where tri hide
                    show = (w - hide)/2, // width of area where tri show
                    triWidth = w * 0.6, // full width of tri
                    left = pos.mousePos.x < show, // show left tri?
                    right = w - pos.mousePos.x < show, // show right tri?
                    leftTri = 0,
                    rightTri = 0,
                    cy = offset.top + (h/2), // center of slider on y-axis
                    // hiding the tri when the mouse is moving away from the slider
                    yFactor = 1 - easing.range(Math.abs(pos.mousePos.y - cy), [h * 0.5, h], 'easeInOutCubic');

                    if (left || right) {
                        var dist = left ? show - pos.mousePos.x : pos.mousePos.x - (w - show),
                            progress = easing.range(dist, [0, show], 'easeOutQuad');

                        if (left) {
                            leftTri = progress * triWidth * yFactor;
                        } else {
                            rightTri = progress * triWidth * yFactor;
                        }
                    }

                    $lftri[0].style.width = Math.round(leftTri * 100) / 100 + 'px';
                    $rttri[0].style.width = Math.round(rightTri * 100) / 100 + 'px';
            });
        },

        remove: function () {
            if (this.mouseAnim) {
                this.mouseAnim.destroy();
            }
            Backbone.View.prototype.remove.call(this);
        }

    }, {
        /**
         * Route filter
         * @type {String}
         */
        filter: 'project'
    });

});
